"use strict";
/**
 * Utility to keep track of the trigger elements that caused trapFocus and the trapped areas root elements
 * This queue lets us return the focus back to the original trigger at every step of releasing the focus
 * In case previous element no longer exists, we traverse the queue backwards until we find one
 *
 * Example:
 * Button open a dropdown menu on click, dropdown menu item opens a sheet and closes dropdown menu
 * Closing the sheet - should return the focuse to the original button
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var TrapFocusQueue = /** @class */ (function () {
    function TrapFocusQueue() {
        this.items = {};
        this.tailId = null;
        this.idCounter = 0;
    }
    TrapFocusQueue.prototype.generateId = function () {
        this.idCounter += 1;
        return this.idCounter;
    };
    TrapFocusQueue.prototype.get = function (id) {
        return this.items[id];
    };
    TrapFocusQueue.prototype.isLast = function (id) {
        return this.tailId !== null && id === this.tailId;
    };
    TrapFocusQueue.prototype.add = function (data) {
        var prevId = this.tailId;
        var prevItem = prevId && this.get(prevId);
        var id = this.generateId();
        this.items[id] = __assign({ prevId: prevId }, data);
        if (prevItem)
            prevItem.nextId = id;
        this.tailId = id;
        return id;
    };
    TrapFocusQueue.prototype.remove = function (id) {
        var _a, _b;
        var target = this.items[id];
        if (!target)
            return;
        var previousId = target.prevId;
        var previousItem = previousId && this.get(previousId);
        var nextId = target.nextId;
        var nextItem = nextId && this.get(nextId);
        if (previousItem)
            previousItem.nextId = (_a = target.nextId) !== null && _a !== void 0 ? _a : null;
        if (nextItem)
            nextItem.prevId = (_b = target.prevId) !== null && _b !== void 0 ? _b : null;
        if (!nextId)
            this.tailId = previousId !== null && previousId !== void 0 ? previousId : null;
        var item = this.get(id);
        delete this.items[id];
        return item;
    };
    TrapFocusQueue.prototype.removeTill = function (id, condition) {
        var target = this.get(id);
        var item = this.remove(id);
        if (!target || !target.prevId)
            return item;
        var keepIterating = !condition(target);
        if (keepIterating)
            return this.removeTill(target.prevId, condition);
        return item;
    };
    return TrapFocusQueue;
}());
exports.default = TrapFocusQueue;
